import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const getRangeByPeriod = (period: string) => {
  const today = dayjs();
  const next4Weeks = today.add(4, "week");
  const next8Weeks = today.add(8, "week");
  const next12Weeks = today.add(12, "week");

  if (period === "next-4-weeks") {
    return {
      from: today.toDate(),
      to: next4Weeks.toDate(),
    };
  }
  if (period === "next-8-weeks") {
    return {
      from: today.toDate(),
      to: next8Weeks.toDate(),
    };
  }
  if (period === "next-12-weeks") {
    return {
      from: today.toDate(),
      to: next12Weeks.toDate(),
    };
  }
};

export const PERIODS = [
  {
    label: "Next 4 weeks",
    value: "next-4-weeks",
  },
  {
    label: "Next 8 weeks",
    value: "next-8-weeks",
  },
  {
    label: "Next 12 weeks",
    value: "next-12-weeks",
  },
  {
    label: "Custom",
    value: "custom",
  },
];

export const MONTHS = [
  {
    label: "Jan",
    value: "january",
  },
  {
    label: "Feb",
    value: "february",
  },
  {
    label: "Mar",
    value: "march",
  },
  {
    label: "Apr",
    value: "april",
  },
  {
    label: "May",
    value: "may",
  },
  {
    label: "Jun",
    value: "june",
  },
  {
    label: "Jul",
    value: "july",
  },
  {
    label: "Aug",
    value: "august",
  },
  {
    label: "Sep",
    value: "september",
  },
  {
    label: "Oct",
    value: "october",
  },
  {
    label: "Nov",
    value: "november",
  },
  {
    label: "Dec",
    value: "december",
  },
];

export const YEARS = Array.from({ length: new Date().getFullYear() - 1998 }, (_, index) => ({
  label: `${1999 + index}`,
  value: `${1999 + index}`,
}));
